import { useState, useEffect } from 'react';
import settingsService from '../services/settingsService';

/**
 * Hook for managing settings data and API operations
 * Handles QuickBooks settings fetch/save and general settings persistence
 */
export const useSettingsData = (activeTab) => {
  const [qbSettings, setQbSettings] = useState({
    clientId: '',
    clientSecret: ''
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (activeTab === 'quickbooks') {
      fetchQuickBooksSettings();
    }
  }, [activeTab]);

  const fetchQuickBooksSettings = async () => {
    try {
      const settings = await settingsService.fetchQuickBooksSettings();
      setQbSettings({
        clientId: settings.qb_global_client_id?.value || '',
        clientSecret: settings.qb_global_client_secret?.value || ''
      });
    } catch (error) {
      console.error('Error fetching QuickBooks settings:', error);
    }
  };

  const saveQuickBooksSettings = async (showNotification) => {
    const result = await settingsService.saveQuickBooksSettings(
      qbSettings, 
      setLoading, 
      showNotification
    );
    return result;
  };

  const updateQbSettings = (updates) => {
    setQbSettings(prev => ({ ...prev, ...updates }));
  };

  return {
    qbSettings,
    loading,
    fetchQuickBooksSettings,
    saveQuickBooksSettings,
    updateQbSettings
  };
};

export default useSettingsData;